import { axios } from "@v2/shared/api";
const PARTICIPANT_ENDPOINT = "participants";
const CATALOG_ORDERS_ENDPOINT = "catalog-orders";

export default {
  get(eventId, orderId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}`
    );
  },

  create(eventId, catalog = {}) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}`,
      {
        ...catalog,
        step: undefined
      }
    );
  },

  update(eventId, catalog = {}, orderId = null) {
    return axios.put(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}`,
      catalog
    );
  },

  submit(eventId, orderId) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/submit`
    );
  },

  getTemplate(eventId, templateId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/catalog-templates/${templateId}`
    );
  },

  getRubrics(eventId) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${eventId}/rubrics`);
  },

  downloadRubrics(eventId, exporter = 0) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/rubrics/download?exporter=${exporter}`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  uploadConfirmationFile(eventId, orderId, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/confirmation`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );
  },

  uploadRequisitesFile(eventId, orderId, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/requisites`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );
  },

  uploadPackageFile(eventId, orderId, data, type) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/${type}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );
  },

  downloadFile(eventId, orderId, type) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/${type}/download`,
      {
        responseType: "arraybuffer"
      }
    );
  },
  downloadOrder(eventId, orderId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/download`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  destroyPackageFile(eventId, orderId, fileId, type) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CATALOG_ORDERS_ENDPOINT}/${orderId}/${type}/${fileId}`
    );
  }
};
